module.exports = require("././angular-resource.js");


//////////////////
// WEBPACK FOOTER
// angular-resource (bower component)
// module id = 409
// module chunks = 1